import { render, staticRenderFns } from "./DiscAlertEdit.vue?vue&type=template&id=306c5740"
import script from "./DiscAlertEdit.vue?vue&type=script&lang=js"
export * from "./DiscAlertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports